import { MessageStore } from "./store/MessageStore";
import { AuthStore } from "./store/AuthStore";
import HttpRequestSetting from "./lib/Common/Http/HttpRequestSetting";
export var SetupHttpRequestUtil;
(function (SetupHttpRequestUtil) {
    var CornerMessageData = MessageStore.CornerMessageData;
    function setup() {
        const httpRequestSetting = new HttpRequestSetting();
        httpRequestSetting.defaultPostProgressMessage = '更新中です';
        httpRequestSetting.defaultDeleteProgressMessage = '削除中です';
        httpRequestSetting.successMessageAction = (message, jsonResponse, option) => {
            console.log(message);
            const cornerMessage = new CornerMessageData(message);
            if (jsonResponse != null) {
                if ('request_button' in jsonResponse) {
                    const requestButtonObject = jsonResponse['request_button'];
                    const requestButtonData = new MessageStore.RequestButtonData();
                    requestButtonData.text = requestButtonObject['text'];
                    requestButtonData.url = requestButtonObject['url'];
                    requestButtonData.body = requestButtonObject['body'];
                    requestButtonData.method = requestButtonObject['method'];
                    requestButtonData.requestCallback = option.successMessageRequestCallback;
                    cornerMessage.requestButton = requestButtonData;
                }
            }
            MessageStore.cornerMessage.set(cornerMessage);
        };
        httpRequestSetting.errorMessageAction = (message, description, jsonResponse) => {
            console.log(message);
            if (message != null) {
                let linkButtonData = null;
                if (jsonResponse != null) {
                    if ('link_button' in jsonResponse) {
                        const linkButtonObject = jsonResponse['link_button'];
                        linkButtonData = new MessageStore.LinkButtonData();
                        linkButtonData.text = linkButtonObject['text'];
                        linkButtonData.url = linkButtonObject['url'];
                    }
                }
                // エラー表示
                MessageStore.showConfirmDanger(message, description, linkButtonData);
            }
        };
        httpRequestSetting.progressMessageAction = (progressMessage) => {
            const fullScreenMessageData = new MessageStore.FullScreenMessageData();
            fullScreenMessageData.message = progressMessage;
            MessageStore.fullScreenMessage.set(fullScreenMessageData);
        };
        httpRequestSetting.finishProgressMessageAction = () => {
            MessageStore.fullScreenMessage.set(null);
        };
        httpRequestSetting.responseNotModifiedActionFunction = () => {
            const message = '変更がありません';
            const cornerMessage = new CornerMessageData(message);
            MessageStore.cornerMessage.set(cornerMessage);
        };
        httpRequestSetting.responseForbiddenActionFunction = (message) => {
            // message を description に設定
            MessageStore.showConfirmDanger('権限がありません', message);
        };
        httpRequestSetting.responseUnAuthorizedActionFunction = () => {
            // 認証状態になっていない場合
            // ログイン画面に戻す
            AuthStore.logout();
        };
        httpRequestSetting.responseServiceUnavailableActionFunction = () => {
            // メンテナンス中の場合
            console.error('Service Unavailable');
            // ログイン画面に戻す
            AuthStore.logout();
        };
        this.setting = httpRequestSetting;
        console.log({ httpRequestSetting });
    }
    SetupHttpRequestUtil.setup = setup;
})(SetupHttpRequestUtil || (SetupHttpRequestUtil = {}));
